/* tslint:disable */
/* eslint-disable */
import { WageCodeType } from '../enums/wage-code-type';
export { WageCodeType }
